import CustomFieldsService from './CustomFieldsService.js'

export const namespaced = true

export const state = {
  customFields: null,
}

export const getters = {
  customFields: state => state.customFields,
}

export const mutations = {
  setCustomFields(state, customFields) {
    state.customFields = customFields
  },
}

export const actions = {
  async maybeFetchCustomFields({ dispatch, state }) {
    return state.customFields ? state.customFields : await dispatch('fetchAllCustomFields')
  },
  async fetchAllCustomFields({ commit }) {
    const customFields = await CustomFieldsService.getCustomFields()
    commit('setCustomFields', customFields)
    return customFields
  },
  async fetchCustomFieldByKey({ dispatch }, key) {
    const customFields = await dispatch('maybeFetchCustomFields')
    return customFields.find(field => field.key === key)
  },
}
